import { isABTestActive } from './components/ab-testing/ABTest';

let activeProfiles: string[];

export function profileEnabled(profile: string) {
    initActiveProfiles();
    return activeProfiles.includes(profile);
}

function initActiveProfiles() {
    if (!activeProfiles) {
        activeProfiles =
            window.OPTIONS.activeProfiles || window.OPTIONS.properties['spring.profiles.active']?.split(',') || [];
    }
}

export const clearActiveProfiles = () => (activeProfiles = []);

export const isProfBetbookRewardsShowInfoEnabled = () => profileEnabled('prof-betbook-rewards-show-info');
export const isProfileAlcasysChatEnabled = () => profileEnabled('prof-alcasys-chat');
export const isProfileBetbookMaintenance = () => profileEnabled('prof-betbook-maintenance');
export const isProfileBetbookSmartViewTipEnabled = () => profileEnabled('prof-betbook-smart-view-tip');
export const isProfileBookingLandscapeEnabled = () => profileEnabled('prof-booking-landscape');
export const isProfileCashinChannelStatusEnabled = () => profileEnabled('prof-cashinChannelStatus');
export const isProfileCashinClosingEnabled = () => profileEnabled('prof-uzatvaranieTipu');
export const isProfileCashinPushIgnoreSequence = () => profileEnabled('prof-cashin-push-ignore-seq');
export const isProfileCasinoLandscapeEnabled = () => profileEnabled('prof-casino-overlay-landscape');
export const isProfileCombinableBetsEnabled = () => profileEnabled('prof-combinable-bets');
export const isProfileContactTopicEnabled = () => profileEnabled('prof-contact-topic');
export const isProfileDiscussionEnabled = () => profileEnabled('prof-discussion');
export const isProfileForcedComfortPayEnabled = () => profileEnabled('prof-forced-comfortpay');
export const isProfileHideInfocentrumEnabled = () =>
    profileEnabled('prof-hide-infocentrum') || localStorage.getItem('prof-hide-infocentrum');
export const isProfileIScratchCardEnabled = () => profileEnabled('prof-i-scratch-card');
export const isProfileIgnorePushSequenceEnabled = () => profileEnabled('prof-push-ignore-seq');
export const isProfileKyc2f2Enabled = () => profileEnabled('prof-kyc2-f2');
export const isProfileNewHomepageEnabled = () => profileEnabled('prof-new-homepage');
export const isProfileNikeTvCakeIconsEnabled = () => profileEnabled('prof-nike-tv-cake-icons');
export const isProfileNoBetslip = () => profileEnabled('prof-no-betslip');
export const isProfileNoForum = () => profileEnabled('prof-noForum');
export const isProfileNoNikeone = () => profileEnabled('prof-no-nikeone');
export const isProfileOlympiaEnabled = () => profileEnabled('prof-olympia');
export const isProfilePlayerProviderFullscreenEnabled = () => profileEnabled('prof-player-provider-fullscreen');
export const isProfilePromoCmsEnabled = () => profileEnabled('prof-promo-cms');
export const isProfileTicketArenaEnabled = () => profileEnabled('prof-ticket-arena') || isABTestActive('ticket-arena');
export const isProfileSportBracketEnabled = () => profileEnabled('prof-sportbracket');
